// @ts-ignore
import { hasProp, assert } from "@utils/assertion";
// @ts-ignore
import { isArray } from "@utils/arrayUtils";
// @ts-ignore
import { parseJsonWithNumbersAsBigint, renderJsonWithNumbersAsBigint, type ParserResult } from "@utils/json";
// @ts-ignore
import { toBase64 } from "@utils/blobUtils";
// @ts-ignore
import { DateTime } from "luxon";
// @ts-ignore
import { type ReadonlyUint8Array } from "@utils/arrayUtils";
import type { Language } from "../schema";

export function serialize_Language_internal(value: Language): unknown {
  return ((value: "en" | "de" | "es" | "ru" | "zh" | "pt" | "fr" | "ar"): unknown => {
    return value;
  })(value);
}
export function serialize_Language(obj: Language): string {
  return renderJsonWithNumbersAsBigint(serialize_Language_internal(obj));
}
export function deserialize_Language_internal(value: unknown): ParserResult<Language> {
  return ((value: unknown): ParserResult<"en" | "de" | "es" | "ru" | "zh" | "pt" | "fr" | "ar"> => {
    if (typeof value !== "string") {
      return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be of type string.` };
    }
    switch (value) {
      case "en":
        return { success: true, value: "en" };
      case "de":
        return { success: true, value: "de" };
      case "es":
        return { success: true, value: "es" };
      case "ru":
        return { success: true, value: "ru" };
      case "zh":
        return { success: true, value: "zh" };
      case "pt":
        return { success: true, value: "pt" };
      case "fr":
        return { success: true, value: "fr" };
      case "ar":
        return { success: true, value: "ar" };
      default:
        return { success: false, reason: `[#/components/schemas/Language]: '${value}' expected to be enum, one of 'en, de, es, ru, zh, pt, fr, ar'.` };
    }
  })(value);
}
export function deserialize_Language(str: string): ParserResult<Language> {
  return deserialize_Language_internal(parseJsonWithNumbersAsBigint(str));
}
